export default __webpack_public_path__ + "static/media/deauville13.7ee7eb56.jpg";